import { SelectedData } from 'owa-addins-core';
import updateContent from 'owa-editor/lib/actions/updateContent';
import { ComposeViewState } from 'owa-mail-compose-store';
import { findComposePlugins } from 'owa-mail-compose-store/lib/plugins/ComposePlugins';
import { ComposeControl } from 'owa-mail-compose-store/lib/utils/getAutoFocusControl';
import BodyType from 'owa-service/lib/contract/BodyType';
import appendOnSend from 'owa-mail-compose-store/lib/actions/appendOnSend';
import { AppendOnSend } from 'owa-addins-core';

export const getBody = (viewState: ComposeViewState) => (): string => {
    return viewState.content;
};

export const setBody = (viewState: ComposeViewState) => (
    content: string,
    bodyType: BodyType
): void => {
    updateContent(viewState, content);
    if (viewState.bodyType == 'HTML') {
        const composePlugins = findComposePlugins(viewState);
        composePlugins.addinPlugin.updateContent(content, bodyType);
    }
};

export const getBodyType = (viewState: ComposeViewState) => (): BodyType => {
    return viewState.bodyType;
};

export const prependBody = (viewState: ComposeViewState) => (content: string) => {
    const { addinPlugin } = findComposePlugins(viewState);
    addinPlugin.prependContent(content);
    updateContent(viewState, addinPlugin.getContent());
};

export const getBodySelectedData = (viewState: ComposeViewState) => (): SelectedData => {
    if (!isEditorLastFocusedControl(viewState)) {
        return null;
    }
    const { addinPlugin } = findComposePlugins(viewState);
    return addinPlugin.getSelectedData();
};

export const setBodySelectedData = (viewState: ComposeViewState) => (content: string) => {
    const { addinPlugin } = findComposePlugins(viewState);
    addinPlugin.setSelectedData(content);
    updateContent(viewState, addinPlugin.getContent());
};

export const appendOnSendAdapter = (viewState: ComposeViewState) => (prop: AppendOnSend) => {
    appendOnSend(viewState, prop);
};

function isEditorLastFocusedControl(viewState: ComposeViewState): boolean {
    return viewState.lastFocusedControl === ComposeControl.Editor;
}
